<h1 class="accent-background-element">Reset the user's password</h1>

@if ((requestOngoingSubject|async) !=true) {
  <mat-dialog-content>
    <h3 class="warn-text-element">Are you sure you want to reset next user password?
    </h3>
    <br>
      <h3>Patient ID:&nbsp;<span class="not-bold">{{currentPatient?.patientId}}</span></h3>
      <h3>Full Name: &nbsp;<span class="not-bold">{{currentPatient?.firstName}} {{currentPatient?.lastName}}</span></h3>
      <h3>E-mail:&nbsp; <span class="not-bold">{{currentPatient?.email}}</span></h3>
      <h3>Shop ID: &nbsp;<span class="not-bold">{{currentPatient?.shopId}}</span></h3>
      <h3>Shop Details: &nbsp;<span class="not-bold">{{[currentPatient?.shopName,currentPatient?.shopAddress].join(", ")}}</span></h3>
    </mat-dialog-content>
  }
  @if (requestOngoingSubject|async) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diameter-30"></mat-spinner>
    </div>
  }
  @if ((requestOngoingSubject|async) !=true) {
    <mat-dialog-actions>
      <button mat-raised-button color="accent" (click)="exit()">No</button>
      <span class="spacer"></span>
      <button mat-raised-button color="warn" (click)="onSubmit()">Yes</button>
    </mat-dialog-actions>
  }

  <ng-template #none>
    <mat-icon svgIcon='dash'></mat-icon>
  </ng-template>